import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import SchoolOverview from "./SchoolOverViewComponent";
import Polarpie from "./Polarpie";
import Phi from "../../../Phi/Phi";
import Constants from "../../../Phi/Constants";
import "./Dashboard.css";
import Rightbar from "./Rightbar";
import RenderYearTab from "../../../Components/shared/RenderYearTab";
import RootLayout from "../../../Components/shared/RootLayout";

const getPrettyDate = (date) => (format) => moment(date).format(format);

const Dashboard = (props) => {
  const schoolOverviewRef = useRef(null);

  useEffect(() => {
    props.setLoader();
    let organization = JSON.parse(Phi.Storage.getItem("organization"));

    if (organization) {
      if (
        props.currentProgram &&
        Object.keys(props.currentProgram).length > 0
      ) {
        let startNode = props.currentProgram.billing
          ? props.startNodeMap[props.currentProgram.billing.id]
          : null;

        if (startNode) {
          props.fetchOverViewReport(startNode.id);
        }
      } else {
        props.getProgramByOrganization(organization[0].org_id);
      }
    }
  }, [props.currentProgram]);

  const downloadPdf = () => {
    props.setLoader();
    let startNode = props.startNodeMap[props.currentProgram.billing.id];
    props.getReport("overview", { eventNodeId: startNode.id, type: "pdf" });
  };

  const changeTab = (nav, type) => {
    let startNode = props.startNodeMap[nav];
    props.setLoader();
    const activeTabMap = {
      year: () => {
        props.changeReportInReducer(nav);
        // props.getReport('overview', { eventNodeId: nav, type: 'html' })
      },
    };

    activeTabMap[type]();
  };

  const getStartNode = (billingId, s_Map) => {
    for (let eachProgram in s_Map) {
      if (s_Map[eachProgram].billing_id === billingId) return eachProgram;
    }
    return false;
  };

  const handleReportTimeChange = (e) => {
    const newBillingId = parseInt(e.target.value, 10);
    const selectedProgram = props.programs.find(
      (p) => p.billing.id === newBillingId,
    );
    const newStartNode = getStartNode(newBillingId, props.startNodeMap);
    props.changeReportInReducer(newBillingId);

    newStartNode &&
      props.fetchOverViewReport(getStartNode(newBillingId, props.startNodeMap));
  };

  const getDropDown = (programs) => (
    <select onChange={(e) => handleReportTimeChange(e)}>
      {programs.map((program) => (
        <option key={program.billing.id} value={program.billing.id}>
          {!!Constants.getNode(program.events, "Schedule Health Checkup")
            ? Constants.getNode(program.events, "Schedule Health Checkup")
                .event_custom_json.event_scheduled_date
              ? getPrettyDate(
                  Constants.getNode(program.events, "Schedule Health Checkup")
                    .event_custom_json.event_scheduled_date,
                )("MMM YYYY")
              : getPrettyDate(program.billing.billingStartDate)("YYYY")
            : ""}
        </option>
      ))}
    </select>
  );

  const getNoProgramsMessage = () => (
    <h4 style={{ paddingLeft: 20 }}> No Programs to show </h4>
  );

  const organization = JSON.parse(Phi.Storage.getItem("organization"));

  return (
    <RootLayout props={props}>
      <div
        style={{
          display: "flex",
          padding: "1.5rem 2em 2em 2em",
          flexDirection: "column",
        }}
      >
        <RenderYearTab
          program={props.currentProgram}
          history={props.history}
          changeTab={changeTab}
        />
        <div
          style={{ display: "flex", flexDirection: "row", gap: "2em", flex: 1 }}
        >
          {/* column 1 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2em",
              flex: 1,
            }}
          >
            <div className="borderRadius  fortemp" ref={schoolOverviewRef}>
              <p className="Bmianalysis ">BMI ANALYSIS</p>
              <hr className="very-straight-line" style={{ margin: "0px" }} />
              {props.programs && props.programs.length ? (
                <div style={{ paddingTop: "20px" }}>
                  {props.overViewReport && (
                    <Polarpie reportData={props.overViewReport} />
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="borderRadius  fortemp" ref={schoolOverviewRef}>
              {props.programs && props.programs.length ? (
                <div>
                  {props.overViewReport && (
                    <SchoolOverview
                      reportData={props.overViewReport}
                      stats={props.episodeStats}
                      organizationId={props.organizationId}
                      fetchEpisodeStats={(
                        organizationId,
                        inStatLimit,
                        inClass,
                        inSection,
                      ) =>
                        props.fetchEpisodeStats(
                          organizationId,
                          inStatLimit,
                          inClass,
                          inSection,
                        )
                      }
                      noDataAvailable={(msg) => _renderNoDataAvail(msg)}
                    />
                  )}
                </div>
              ) : (
                getNoProgramsMessage()
              )}
            </div>
          </div>
          {/* column 2 */}
          <div style={{ flex: 0.7 }}>
            <div
              className="fortemp   borderRadius"
              style={{
                flex: 1,
                border: "1px solid white",
              }}
              ref={schoolOverviewRef}
            >
              <p className="Bmianalysis ">SCHOOL OVERVIEW</p>
              <hr className="very-straight-line" style={{ margin: "0px" }} />

              {props.programs && props.programs.length ? (
                <>
                  {props.overViewReport && (
                    <Rightbar reportData={props.overViewReport} />
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </RootLayout>
  );
};

export default Dashboard;
